import { makeWriteScope, type AssetWriteScope } from '@gotti/core';
import type { ServerAssetManager } from './ServerAssetManager.js';

export interface ServerAssetsFacade {
  client: AssetWriteScope;
  server: AssetWriteScope;
}

export function makeServerAssetsFacade(mgr: ServerAssetManager): ServerAssetsFacade {
  return {
    client: makeWriteScope(mgr, 'client'),
    server: makeWriteScope(mgr, 'server'),
  };
}
